import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Modal from 'components/atoms/Modal'
import Radio from 'components/atoms/Radio'

const AttachTemplateOptionsModal = ({
  open,
  onClose,
  onSubmit,
  templateName,
  initialVisibility = 'shared'
}) => {
  const [visibility, setVisibility] = useState(initialVisibility)

  useEffect(() => {
    if (open) {
      setVisibility(initialVisibility || 'shared')
    }
  }, [open, initialVisibility])

  const handleSubmit = () => {
    onSubmit({ visibility })
  }

  return (
    <Modal
      open={open}
      title={templateName ? `Attach “${templateName}”` : 'Attach template'}
      onClose={onClose}
      withSubmit
      withCancel
      submitButtonText="Next"
      cancelButtonText="Cancel"
      onSubmit={handleSubmit}
      onCancel={onClose}
    >
      <Section>
        <SectionTitle>Visibility</SectionTitle>
        <OptionRow onClick={() => setVisibility('shared')}>
          <Radio checked={visibility === 'shared'} />
          <div>
            <OptionLabel>Shared</OptionLabel>
            <OptionHint>All Building Passport users will see this template.</OptionHint>
          </div>
        </OptionRow>
        <OptionRow onClick={() => setVisibility('personal')}>
          <Radio checked={visibility === 'personal'} />
          <div>
            <OptionLabel>Personal</OptionLabel>
            <OptionHint>Only you will see this template.</OptionHint>
          </div>
        </OptionRow>
      </Section>
    </Modal>
  )
}

export default AttachTemplateOptionsModal

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const SectionTitle = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.haiti};
  margin-bottom: 4px;
`

const OptionRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
`

const OptionLabel = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.haiti};
`

const OptionHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey[700]};
  margin-top: 2px;
`
